// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronRightIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 17a1 1 0 01-.71-.29 1 1 0 010-1.42l3.3-3.29-3.3-3.29a1 1 0 111.42-1.42l4 4a1 1 0 010 1.42l-4 4A1 1 0 0110 17z" fill="currentColor"/></svg>'} />;

ChevronRightIcon.displayName = 'ChevronRightIcon';

export default ChevronRightIcon;
